0<template>
      <WindowForAlert :title="$t('fill3rd158',[data.sn,'选择xxx的子设备'])" ref="intentSelectWindow" :size="'m'" class="windowWidth" :btnCancel="false">
        <div id="editDeviceLine">
            	<NewDevice :data="data" @update="update" ref="newDevice" @hide="hide" v-if="ndshow"></NewDevice>
            	<div><button :class="{'disable':temp.length==0}" class="fR functionBtn" :title="getLanguageStr('cmd12','确定')" @click="makeSure">{{getLanguageStr('cmd12','确定')}}({{temp.length}})</button></div>
        </div>
      </WindowForAlert>
    </div>
</template>
<script>
import NewDevice from './NewDevice'
import {getLanguageStr} from '@/util/language.js'
import {GetSystemDevice} from '@/api/maintain/plant/list'
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import * as lib from '@/util/lib.js'
import {GetGateway, apiAddDevice} from '@/api/maintain/plant/list.js'
export default {
  name: 'addDeviceLine',
  components: {NewDevice,WindowForAlert},
  props: {
    id: {
      type: Number
    },
    data: {
      type: Object
    },
    buttonType: {
      type: String,
      default: 'add'
    },
    stationId:{
      type: [Number,String]
    },
    timezone:{
      type:String,
      default:stage.time.timeZoneCode
    }
  },
  inject: ['yeye'],
  data () {
    return {
    	ndshow:false,
    	temp:[]
    }
  },
  watch:{
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    timeFormat: lib.timeFormat,
    show(){
    	this.$refs.intentSelectWindow.show();
    	this.ndshow=true;
    	this.$nextTick(() => {
        this.temp=[];
    		this.$refs.newDevice.show(true);
    	});
    },
    hide(){
    	 this.temp=[];
    	   this.$refs.intentSelectWindow.hide()
    },
    update(data){
      this.temp=data
    },
    makeSure(){
    		   apiAddDevice(this.stationId, this.temp).then(res => {
             this.temp=[];
         this.$refs.intentSelectWindow.hide()
         this.yeye.ref.ChildSys.ref.refreshTree();
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/AddDevice/EditDeviceLine.vue